<h2 mat-dialog-title>Advertencias de Configuración</h2>
<mat-dialog-content>
  @if (warnings && warnings.length > 0) {
    <ol>
      @for(warning of warnings; track warning.name){
        <li>
          {{warningsTranslations[warning.name].text}}
          @if (warningsTranslations[warning.name].link) {
            <a routerLink="{{warningsTranslations[warning.name].link}}" [mat-dialog-close]="warnings"><mat-icon>arrow_forward</mat-icon></a>
          }
          @if (warning.values.length > 0) {
            <ol>
              @for(value of warning.values; track value){
                <li class="li">{{value}}</li>
              }
            </ol>
          }
        </li>
      }
    </ol>
  }
  @else {
    <p>No hay advertencias</p>
  }
</mat-dialog-content>
<div mat-dialog-actions>
  <button mat-raised-button class="btn-action" (click)="getWarnings()">
    @if (loading) {
      <mat-spinner [diameter]="20"></mat-spinner>
    } @else {
      <div class="btn-action__content"><mat-icon>refresh</mat-icon> <span>Actualizar</span></div>
    }
  </button>
</div>
